<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import Lianjie from "./../home/repeat/Lianjie.vue";
import Header from "./../home/repeat/Header.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import Navbar from "../home/repeat/Navbar.vue";
import axios from "./../../utils/axios.js";
import book_downLoad from "./../../assets/imgs/book_downLoad.png";
import img_downLoad from "./../../assets/imgs/img_downLoad.png";
import video_downLoad from "./../../assets/imgs/video_downLoad.png";

const router = useRouter();


</script>

<template>
  <div class="news">
    <div class="main">
      <div class="kong">
        <Header></Header>
      </div>
      <div class="img_box"></div>
      <div class="wrap">
        <div class="wrap_title">
          <div class="title_box">
            <div class="title">
              <a class="no" href="/">{{ $t("system.contact.register.s_y") }}</a>
              <text>></text>
              <a class="th">{{ $t("system.map.mediaCenter") }}</a>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="media-container">
            <div class="media-header">
              <div class="header-left">
                <img :src="img_downLoad" alt="海报" class="header-icon" />
                <span class="header-text">海报</span>
              </div>
              <div class="header-line"></div>
            </div>
            <div class="poster-grid">
              <div class="poster-item" v-for="i in 4" :key="i">
                <div class="poster-image"></div>
                <div class="poster-info">
                  <p class="poster-title">vika电子水泵</p>
                  <a class="download-link">下载</a>
                </div>
              </div>
            </div>

            <div class="media-header">
              <div class="header-left">
                <img :src="book_downLoad" alt="画册" class="header-icon" />
                <span class="header-text">画册</span>
              </div>
              <div class="header-line"></div>
            </div>
            <div class="album-grid">
              <div class="album-item" v-for="i in 3" :key="i">
                <div class="album-image"></div>
                <div class="album-info">
                  <p class="album-title">2022宣传册</p>
                  <a class="download-link">下载</a>
                </div>
              </div>
            </div>

            <div class="media-header">
              <div class="header-left">
                <img :src="video_downLoad" alt="产品视频" class="header-icon" />
                <span class="header-text">产品视频</span>
              </div>
              <div class="header-line"></div>
            </div>
            <div class="video-grid">
              <div class="video-item" v-for="i in 3" :key="i">
                <div class="video-image"></div>
                <div class="video-info">
                  <p class="video-title">大灯</p>
                  <!-- <a class="download-link">下载</a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"></Navbar>
  </div>
</template>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.main {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.kong {
  max-width: 1200px;
  height: 120px;
}

.img_box {
  width: 100%;
  height: 553px;
  position: relative;
  background-image: url("./../../assets/imgs/prodList_backgronud.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100% 100%;
}

.wrap {
  width: 100%;
  height: auto;
}

.wrap_title {
  padding: 30px 0;
  width: 100%;
  color: #3e3a39;
  background-color: #fff;
  font-size: 14px;
  height: 86px;
}

.title_box {
  width: 100%;
  max-width: 1230px;
  padding: 0 15px;
  margin: 0 auto;
}

.title {
  width: 100%;
  height: 100%;
  font-size: 18px;
  margin: 0 -8px;
}

.title a {
  display: inline-block;
  padding: 0 8px;
  font-weight: bold;
  color: #696b71;
}

.content_box {
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
}
.media-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}
// ... 原有样式保持不变 ...

.media-header {
  display: flex;
  align-items: flex-end;  // 改为底部对齐
  margin-bottom: 30px;
  padding: 10px 0;
}

.header-left {
  display: flex;
  align-items: flex-end;  // 改为底部对齐
  margin-right: 20px;
}

.header-icon {
  width: 70px;
  height: 70px;
  margin-right: 12px;
}

.header-text {
  font-size: 20px;
  color: #333;
  font-weight: 500;
  line-height: 1;  // 添加行高
}

.header-line {
  flex: 1;
  height: 1px;
  background-color: #e5e5e5;
}
// 移除原来的 section-title 相关样式
.section-title {
  display: none;
}
.poster-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin-bottom: 50px;
}

.video-grid,
.album-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);  // 修改为固定3列
  gap: 30px;
  margin-bottom: 50px;
}

.poster-item,
.video-item,
.album-item {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
}

.poster-image,
.video-image,
.album-image {
  width: 100%;
  height: 380px;
  background-color: #f5f5f5;
  border: 1px solid #eee;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.poster-info,
.video-info,
.album-info {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.poster-title,
.video-title,
.album-title {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.download-link {
  color: #004080;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }
}
</style>
